import { render } from "./CpsPrompt.vue?vue&type=template&id=35ae8929&scoped=true&ts=true"
import script from "./CpsPrompt.vue?vue&type=script&lang=ts"
export * from "./CpsPrompt.vue?vue&type=script&lang=ts"

import "./CpsPrompt.vue?vue&type=style&index=0&id=35ae8929&lang=scss&scoped=true"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ae8929"]])

export default __exports__